/* eslint-disable padding-line-between-statements */
import React, { useCallback, useMemo, useEffect, useContext, useState } from 'react';
import _ from 'lodash';
import { appendMetadataWithIndex } from '@xengage/gw-jutro-adapters-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';
import { Icon } from '@jutro/components';
import { useTranslator } from '@jutro/locale';
import metadata from './SafetyEquipmentComponent.metadata.json5';
import messages from './SafetyEquipmentComponent.messages';
import styles from './SafetyEquipmentComponent.module.scss';

import { Button, InputField, InputNumberField } from '@jutro/legacy/components';

function SafetyEquipmentComponent(props) {

    const {
        id,
        value: safetyEquipmentsVM,
        onValueChange,
        onValidate,
        index,
        path,
        handleAddSafetyEquipment
    } = props;

    const translator = useTranslator();
    const viewModelService = useContext(ViewModelServiceContext);	
    const { isComponentValid, onValidate: setComponentValidation } = useValidation(id);


    useEffect(() => {
        if (onValidate) {
            onValidate(isComponentValid, id);
        }
        
    }, [id, isComponentValid, onValidate]);

    const handleValueChange = useCallback(
        (value, changedPath) => {
            if (onValueChange) {
                onValueChange(value, changedPath);
            }
        },
        [onValueChange]
    );

    const generateNewSafetyEquipmentRow = useCallback(
        (event) => {
            event.preventDefault();
            if (safetyEquipmentsVM.value === undefined) {
                safetyEquipmentsVM.value = [];
            }
            const { _xCenter, _dtoName } = safetyEquipmentsVM;
            const safetyEquipmentRecordVM = viewModelService.create({},_xCenter, _dtoName);
            handleAddSafetyEquipment(safetyEquipmentRecordVM);
        },
        [safetyEquipmentsVM, path, viewModelService, handleAddSafetyEquipment ]
    );

    const getSafetyEquipmentTableCell =  useCallback(
        (item, index, props) => {
           let path = props.path;
           const value = item[path];
            if (props.path == 'equipmentName') {
                path  = `safetyEquipments.children[${index}].${path}`;
                return (
                    <InputField
                        dataType="string"
                        id={index + path}
                        value={value}
                        path={path}
                        onValueChange={handleValueChange}
                    />
                );
            }
            else if (props.path == 'equipmentValue') {
                path  = `safetyEquipments.children[${index}].${path}`;
                return (
                    <InputNumberField
                        id={index + path}
                        value={value}
                        path={path}
                        onValueChange={handleValueChange}
                    />
                );
            }
        },
        [ handleValueChange]
    );

    const removeSafetyEquipmentRecordVM = useCallback(
        (rowIndex) => {
            safetyEquipmentsVM.value.splice(rowIndex, 1);
            handleValueChange(safetyEquipmentsVM.value, path);
        },
        [ path, handleValueChange]
    );

    const removeSafetyEquipmentRow = useCallback(
        (item, index) => {
            return (
                <Button onClick={(e) => removeSafetyEquipmentRecordVM(index, item)}>
                    <Icon icon="mi-delete" />
                </Button>
            );
        },
        [removeSafetyEquipmentRecordVM]
    );



    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = useMemo(() => ({
        "@field": {
            showRequired: true,
            showOptional: false,
            labelPosition: 'left',
        },
        [`safetyEquipmentTableSection${index}`]:{
            visible : safetyEquipmentsVM && safetyEquipmentsVM.value && safetyEquipmentsVM.value.length > 0
        },
        [`safetyEquipmentTable${index}`]:{
            data :  safetyEquipmentsVM ? safetyEquipmentsVM.value : []
        }
    }),[safetyEquipmentsVM]);

    const resolvers = {
        resolveCallbackMap: {
            generateNewSafetyEquipmentTableRow: generateNewSafetyEquipmentRow,
            removeSafetyEquipmentTableRow: removeSafetyEquipmentRow,
            getSafetyEquipmentTableCell
        }
    };

    const formattedMetadata = useMemo(() => appendMetadataWithIndex(metadata.pageContent, index), [index]);

    return (
        <ViewModelForm
            uiProps={formattedMetadata}
            model={safetyEquipmentsVM}
            overrideProps={overrideProps}
            onValidationChange={setComponentValidation}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={styles}
        />
    );

}

export default SafetyEquipmentComponent;